export default {
  'user-register.login.userName': '賬戶',
  'user-register.login.password': '密碼',
  'user-register.login.message-invalid-credentials': '賬戶或密碼錯誤（admin/ant.design）',
  'user-register.login.message-invalid-verification-code': '驗證碼錯誤',
  'user-register.login.tab-login-credentials': '賬戶密碼登錄',
  'user-register.login.tab-login-mobile': '手機號登錄',
  'user-register.login.remember-me': '自動登錄',
  'user-register.login.forgot-password': '忘記密碼',
  'user-register.login.sign-in-with': '其他登錄方式',
  'user-register.login.signup': '註冊賬戶',
  'user-register.login.login': '登錄',
  'user-register.register.register': '註冊',
  'user-register.register.get-verification-code': '獲取驗證碼',
  'user-register.register.sign-in': '使用已有賬戶登錄',
  'user-register.register-result.msg': '妳的賬戶：{email} 註冊成功',
  'user-register.register-result.activation-email':
    '激活郵件已發送到妳的郵箱中，郵件有效期為24小時。請及時登錄郵箱，點擊郵件中的鏈接激活帳戶。',
  'user-register.register-result.back-home': '返回首頁',
  'user-register.register-result.view-mailbox': '查看郵箱',
  'user-register.email.required': '請輸入郵箱地址！',
  'user-register.email.wrong-format': '郵箱地址格式錯誤！',
  'user-register.userName.required': '請輸入賬戶!',
  'user-register.password.required': '請輸入密碼！',
  'user-register.password.twice': '兩次輸入的密碼不匹配!',
  'user-register.strength.msg': '請至少輸入 6 個字符。請不要使用容易被猜到的密碼。',
  'user-register.strength.strong': '強度：強',
  'user-register.strength.medium': '強度：中',
  'user-register.strength.short': '強度：太短',
  'user-register.confirm-password.required': '請確認密碼！',
  'user-register.phone-number.required': '請輸入手機號！',
  'user-register.phone-number.wrong-format': '手機號格式錯誤！',
  'user-register.verification-code.required': '請輸入驗證碼！',
  'user-register.title.required': '請輸入標題',
  'user-register.date.required': '請選擇起止日期',
  'user-register.goal.required': '請輸入目標描述',
  'user-register.standard.required': '請輸入衡量標淮',
  'user-register.form.get-captcha': '獲取驗證碼',
  'user-register.captcha.second': '秒',
  'user-register.form.optional': '（選填）',
  'user-register.form.submit': '提交',
  'user-register.form.save': '保存',
  'user-register.email.placeholder': '郵箱',
  'user-register.password.placeholder': '至少6位密碼，區分大小寫',
  'user-register.confirm-password.placeholder': '確認密碼',
  'user-register.phone-number.placeholder': '手機號',
  'user-register.verification-code.placeholder': '驗證碼',
  'user-register.title.label': '標題',
  'user-register.title.placeholder': '給目標起個名字',
  'user-register.date.label': '起止日期',
  'user-register.placeholder.start': '開始日期',
  'user-register.placeholder.end': '結束日期',
  'user-register.goal.label': '目標描述',
  'user-register.goal.placeholder': '請輸入妳的階段性工作目標',
  'user-register.standard.label': '衡量標淮',
  'user-register.standard.placeholder': '請輸入衡量標淮',
  'user-register.client.label': '客戶',
  'user-register.label.tooltip': '目標的服務對象',
  'user-register.client.placeholder': '請描述妳服務的客戶，內部客戶直接 @姓名／工號',
  'user-register.invites.label': '邀評人',
  'user-register.invites.placeholder': '請直接 @姓名／工號，最多可邀請 5 人',
  'user-register.weight.label': '權重',
  'user-register.weight.placeholder': '請輸入',
  'user-register.public.label': '目標公開',
  'user-register.label.help': '客戶、邀評人默認被分享',
  'user-register.radio.public': '公開',
  'user-register.radio.partially-public': '部分公開',
  'user-register.radio.private': '不公開',
  'user-register.publicUsers.placeholder': '公開給',
  'user-register.option.A': '同事甲',
  'user-register.option.B': '同事乙',
  'user-register.option.C': '同事丙',
  'user-register.navBar.lang': '語言',
};
